// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { Vector3 } from './vector3';


export class Plane {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
__init(i:number, bb:flatbuffers.ByteBuffer):Plane {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPlane(bb:flatbuffers.ByteBuffer, obj?:Plane):Plane {
  return (obj || new Plane()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPlane(bb:flatbuffers.ByteBuffer, obj?:Plane):Plane {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Plane()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

guid():string|null
guid(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
guid(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

imageGuid():string|null
imageGuid(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
imageGuid(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

label():string|null
label(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
label(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

color():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

isVisible():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

ptOrigin(obj?:Vector3):Vector3|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? (obj || new Vector3()).__init(this.bb_pos + offset, this.bb!) : null;
}

vecNormal(obj?:Vector3):Vector3|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? (obj || new Vector3()).__init(this.bb_pos + offset, this.bb!) : null;
}

width():number {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
}

height():number {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
}

vecWidth(obj?:Vector3):Vector3|null {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? (obj || new Vector3()).__init(this.bb_pos + offset, this.bb!) : null;
}

vecHeight(obj?:Vector3):Vector3|null {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? (obj || new Vector3()).__init(this.bb_pos + offset, this.bb!) : null;
}

ptMiddle(obj?:Vector3):Vector3|null {
  const offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? (obj || new Vector3()).__init(this.bb_pos + offset, this.bb!) : null;
}

static startPlane(builder:flatbuffers.Builder) {
  builder.startObject(12);
}

static addGuid(builder:flatbuffers.Builder, guidOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, guidOffset, 0);
}

static addImageGuid(builder:flatbuffers.Builder, imageGuidOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, imageGuidOffset, 0);
}

static addLabel(builder:flatbuffers.Builder, labelOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, labelOffset, 0);
}

static addColor(builder:flatbuffers.Builder, color:number) {
  builder.addFieldInt32(3, color, 0);
}

static addIsVisible(builder:flatbuffers.Builder, isVisible:boolean) {
  builder.addFieldInt8(4, +isVisible, +false);
}

static addPtOrigin(builder:flatbuffers.Builder, ptOriginOffset:flatbuffers.Offset) {
  builder.addFieldStruct(5, ptOriginOffset, 0);
}

static addVecNormal(builder:flatbuffers.Builder, vecNormalOffset:flatbuffers.Offset) {
  builder.addFieldStruct(6, vecNormalOffset, 0);
}

static addWidth(builder:flatbuffers.Builder, width:number) {
  builder.addFieldFloat64(7, width, 0.0);
}

static addHeight(builder:flatbuffers.Builder, height:number) {
  builder.addFieldFloat64(8, height, 0.0);
}

static addVecWidth(builder:flatbuffers.Builder, vecWidthOffset:flatbuffers.Offset) {
  builder.addFieldStruct(9, vecWidthOffset, 0);
}

static addVecHeight(builder:flatbuffers.Builder, vecHeightOffset:flatbuffers.Offset) {
  builder.addFieldStruct(10, vecHeightOffset, 0);
}

static addPtMiddle(builder:flatbuffers.Builder, ptMiddleOffset:flatbuffers.Offset) {
  builder.addFieldStruct(11, ptMiddleOffset, 0);
}

static endPlane(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

}
